import FormHelpers from '../util/form';
import {newModalFromString} from '../components/modal';
import Customer from './customer';
import Plugins from 'util/plugins';

class RegistrationHelper {
    constructor () {
        this.currentStage = 'email';
    }

    modalRegistrationInit () {
        var _self = this;
        $('.js-modal-registration').on('click', function (e) {
            e.preventDefault();
            const socialLogin = $(this).closest('.tingle-modal-box__content').find('.js-gigya-login-wrp').clone();
            _self.closeLoginModal();
            let url = $('#registrationModalURL').data('url');
            if (!url) {
                console.error('Missing URL for AJAX call');
                return;
            }
            $.ajax(url).then(data => {
                var modal = newModalFromString(
                    data, false, ['layer-login-modal', 'cc-layer-login', 'cc-registrationModal', 'wrapperModalLogin'], null
                );
                modal.open();
                $('.tingle-modal-box').addClass('rightModalAttribute');
                $('.registration-modal').addClass('open');
                $(modal.modalBox)
                    .find('.close-button-info')
                    .on('click', function () {
                        modal.close();
                    });
                $('#gender_chosen').remove();
                Plugins.init();
                FormHelpers.init();
                Customer.accountRegisterForm();
                Customer.accountLoyaltyForm();
                _self.buttonSubmissionInit();
                _self.buttonBackInit();
                _self.datePickerInit();
                _self.updateButtonStatusInit();
                _self.singleNumberOTPinput();
                _self.shiftFieldWhileTypingInit();
                if ($('.js-gigya-registration-wrp .gigyaLoginCell').length < 1) {
                    $('.js-gigya-registration-wrp').append(socialLogin);
                }
                _self.moveToNextStep('email');
            });
        });
    };

    modalLoyaltyRegistrationInit () {
        var _self = this;
        $('.js-modal-loyalty-registration, .js-modal-loyalty-registration-fake').on('click', function (e) {
            e.preventDefault();
            _self.closeLoginModal();
            let url = $('#registrationLoyaltyModalURL').data('url');
            if (!url) {
                console.error('Missing URL for AJAX call');
                return;
            }
            $.ajax(url).then(data => {
                var modal;
                const onClose = () => {
                    location.reload();
                };
                modal = newModalFromString(data, false, ['layer-login-modal', 'cc-layer-login', 'cc-registrationModal', 'cc-registrationModal--loyalty', 'wrapperModalLogin'], null, onClose);
                modal.open();
                $('.tingle-modal-box').addClass('rightModalAttribute');
                $('.registration-loyalty-modal').addClass('open');
                $('.js-returnOpen-loyaltyPopup .js-returnOpen-loyaltyPopupCloseIcon').trigger('click');
                $(modal.modalBox)
                    .find('.close-button-info')
                    .on('click', function () {
                        modal.close();
                    });
                _self.datePickerInit();
                Customer.accountRegisterForm();
                Customer.accountLoyaltyForm();
                _self.proceedToRegistrationLoyaltyInit();
                _self.buttonBackInit();
                _self.moveToNextStep('content');
            });
        });
    }

    isNewRegistrationActive () {
        return $('#isNewRegistrationActive').val() === 'true';
    }

    isRegistrationModalFlow () {
        return $('.registration-modal').hasClass('open');
    }

    isRegistrationLoyaltyModalFlow () {
        return $('.registration-loyalty-modal').hasClass('open');
    }

    isLoyaltyAvailable () {
        return $('#isLoyaltyAvailable').val() === 'true';
    }

    moveToNextStep (step) {
        if (step === 'phone' && $('.registrationModal-box').attr('data-registration-modal-skip-phone') === 'true') {
            step = 'personal-info';
        }
        $('.registrationModal-box').attr('data-registration-modal-stage', step);
        $('#login-warn-label').addClass('hidden');
        $('#registration-form-phone').attr('placeholder', '');
    }

    handleExistingAccount (data) {
        $('#login-warn-label').text(data.warn);
        $('#login-warn-label').removeClass('hidden');
        $('#registration-form-phone').attr('placeholder', data.hiddenPhonePlaceholder);
    }

    handleCustomerInfo (customerInfo) {
        var prefix = $('#registration-form-prefix').val();
        var gender = customerInfo.gender;
        var mobileNumber = customerInfo.mobileNumber;
        var genderMap = { 'M': '1', 'F': '2', 'X': '3', 'Y': '4' };
        gender = genderMap[gender.toUpperCase()] || '1';
        mobileNumber = mobileNumber.substring(prefix.length);
        $('#registration-form-email').val(customerInfo.email);
        $('#registration-form-phone').val(mobileNumber);
        $('#registration-form-fname').val(customerInfo.firstName);
        $('#registration-form-lname').val(customerInfo.lastName);
        $('#registration-form-email').parent('.label-inside').addClass('focused');
        $('#registration-form-phone').parent('.label-inside').addClass('focused');
        $('#registration-form-fname').parent('.label-inside').addClass('focused');
        $('#registration-form-lname').parent('.label-inside').addClass('focused');
        $('#gender-' + gender).trigger('click');

        this.fillEmailText(customerInfo.email);
        this.fillPhoneText(customerInfo.mobileNumber);
    }

    fillEmailText (email) {
        $('.email-label').text(email);
    }

    fillPhoneText (phone) {
        $('.phone-label').text(phone);
    }

    fieldsFormPrefill (data) { // MEC-30353

        if (data.fieldsForm.loyalty.hide === true) { // At the moment, only registration where a potential customer already has loyalty.
            if (data.fieldsForm.firstName.value) {
                $('#registration-form-fname').val(data.fieldsForm.firstName.value); // First name             
                if (data.prefillCustomerData) {
                    $('#registration-form-fname').attr('readonly', 'readonly');
                }
            }

            if (data.fieldsForm.lastName.value) {
                $('#registration-form-lname').val(data.fieldsForm.lastName.value);  // Last name
                if (data.prefillCustomerData) {
                    $('#registration-form-lname').attr('readonly', 'readonly');
                }
            }

            // Gender 
            if (data.fieldsForm.gender.value === 'M') {
                $('#gender option[value="1"]').prop('selected', true);  // MALE
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'F') {
                $('#gender option[value="2"]').prop('selected', true);  // FEMALE
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'X') {
                $('#gender option[value="3"]').prop('selected', true);  // OTHER
                $('#gender').trigger('chosen:updated');
            } else if (data.fieldsForm.gender.value === 'U') {
                $('#gender option[value="4"]').prop('selected', true);  // PREFER NOT TO SAY
                $('#gender').trigger('chosen:updated');
            }

            if (data.fieldsForm.loyalty.hide) {
                $('.cc-registrationModal__loyalty').addClass('hidden'); // Loyalty box
            }

            if (data.prefillPrivacyFlag) {
                $('.prefill-privacy-flag').removeClass('hidden');   // Message about already given privacy consents
            
                if (data.fieldsForm.directMarketingAgreement.value) {
                    $('#add-to-email-list-yes').prop('checked', true);  // YES - Newsletter
                    
                    $('.js-personalized-news-container').removeClass('transparent');    // Newsletter personalized - box opacity
                    $('#add-to-personalized-news-list-no').removeAttr('disabled');
                    $('#add-to-personalized-news-list-yes').removeAttr('disabled');
                        
                    if (data.fieldsForm.profilingAgreement.value) {
                        $('#add-to-personalized-news-list-yes').prop('checked', true);  // YES - Newsletter personalized
                    } else {
                        $('#add-to-personalized-news-list-no').prop('checked', true);   // NO - Newsletter personalized
                    }

                } else {
                    $('#add-to-email-list-no').prop('checked', true);               // NO - Newsletter
                    $('#add-to-personalized-news-list-no').prop('checked', true);   // NO - Newsletter personalized
                }
            }

            $('.registrationModal-box').attr('data-registration-modal-stage-for-a-loyalty-user', 'true');
        }
    }

    fieldsFormClear () {
        
        $('#registration-form-fname').val('');  // First name
        $('#registration-form-lname').val('');  // Last name

        $('#gender option[value=""]').prop('selected', true);   // Gender 
        $('#gender').trigger('chosen:updated');

        $('.cc-registrationModal__loyalty').removeClass('hidden');  // Loyalty box

        $('.prefill-privacy-flag').addClass('hidden');  // Message about already given privacy consents

        $('#add-to-email-list-yes').prop('checked', false); // YES - Newsletter
        $('#add-to-email-list-no').prop('checked', false);  // NO - Newsletter

        $('.js-personalized-news-container').addClass('transparent');   // Newsletter personalized - box opacity
        
        $('#add-to-personalized-news-list-yes').prop('checked', false); // YES - Newsletter personalized 
        $('#add-to-personalized-news-list-yes').attr('disabled','disabled');
        $('#add-to-personalized-news-list-no').prop('checked', false);   // NO - Newsletter personalized
        $('#add-to-personalized-news-list-no').attr('disabled', 'disabled');
                    
        $('.registrationModal-box').removeAttr('data-registration-modal-stage-for-a-loyalty-user'); // to remove all occurences, if all types of users get their data prefilled
    }

    buttonSubmissionInit () {
        var _self = this;
        $('.js-register-otp').on('click', function (e) {
            e.preventDefault();
            $.spinner().start();
            var email = $('#registration-form-email').val();
            var otpCodeInput = $('#otp-code-input-1').val() + $('#otp-code-input-2').val() + $('#otp-code-input-3').val() + $('#otp-code-input-4').val() + $('#otp-code-input-5').val();
            let url = $(e.currentTarget).data('registration-otp-url');
            let formData = {
                email: email,
                otpCodeInput: otpCodeInput
            };
            $.ajax({
                url: url,
                type: 'GET',
                data: formData,
                success: function (data) {
                    if (data.unmatchOtp) {
                        $('.wrong-opt-inserted').removeClass('hidden');
                        $('.expired-opt-inserted').addClass('hidden');
                        $('body').trigger('analytics:registerConfirmOptin', { 'error': true });
                        $.spinner().stop();
                        return;
                    } else if (data.expiredOtp) {
                        $('.expired-opt-inserted').removeClass('hidden');
                        $('.wrong-opt-inserted').addClass('hidden');
                        $('body').trigger('analytics:registerConfirmOptin', { 'error': true });
                        $.spinner().stop();
                        return;
                    } else if (data.alreadyRegistered) {
                        $('.expired-opt-inserted').addClass('hidden');
                        $('.wrong-opt-inserted').addClass('hidden');
                        _self.closeRegistrationOpenLoginRegistered();
                        $.spinner().stop();
                        return;
                    }
                    $('.expired-opt-inserted').addClass('hidden');
                    $('.wrong-opt-inserted').addClass('hidden');
                    $('body').trigger('analytics:registerConfirmOptin', { 'error': false });
                    _self.loginAfterRegistration();
                    if ($('.page').data('action') === 'Cart-Show') {
                        location.reload();
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    buttonBackInit () {
        var _self = this;
        $('.js-back-step-arrow').on('click', function (e) {
            var $registrationModal = $('.registrationModal-box');
            var currentStep = $registrationModal.attr('data-registration-modal-stage');
            switch (currentStep) {
            case 'email':
            case 'email_only' :
                _self.closeRegistrationOpenLogin();
                break;
            case 'phone' :
                $registrationModal.attr('data-registration-modal-stage', 'email');
                break;
            case 'personal-info' :
                if ($('.registrationModal-box').attr('data-registration-modal-skip-phone') === 'true') {
                    $registrationModal.attr('data-registration-modal-stage', 'email');
                } else {
                    $registrationModal.attr('data-registration-modal-stage', 'phone');
                }

                if ($('.registrationModal-box').attr('data-registration-modal-stage-for-a-loyalty-user')) {
                    _self.fieldsFormClear();
                }

                break;
            case 'waiting-room' :
                $registrationModal.attr('data-registration-modal-stage', 'personal-info');
                break;
            case 'registration' :
                $registrationModal.attr('data-registration-modal-stage', 'content');
                break;
            }
        });
    }

    closeRegistrationOpenLoginInit () {
        var _self = this;
        if (_self.isRegistrationModalFlow()) {
            $('.js-close-registration-open-login').on('click', function (e) {
                e.preventDefault();
                _self.closeRegistrationOpenLogin();
            });
            $('.js-close-registration-open-forgot').on('click', function (e) {
                e.preventDefault();
                _self.forgotPassword(e);
            });
        }
    }

    datePickerInit () {
        var _self = this;
        let formatPattern = $('.datepickerTriggerElement').data('date-format-pattern');

        $('.datepickerTriggerElement').fdatepicker({
            format: formatPattern,
            disableDblClickSelection: true,
            leftArrow: '<<',
            rightArrow: '>>',
            closeIcon: 'X',
            closeButton: false
        }).on('changeDate', function (ev) {
            let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
            var datestring = _self.formatDate(date, formatPattern);
            $('#dpReg').val(datestring);
            $('.datepickerTriggerElement').data('date', datestring);
            $('.disabledForm').prop('disabled', false);
        });
    }

    proceedToRegistrationLoyaltyInit () {
        $('.js-proceed-to-loyalty-modal').on('click', function () {
            $('body').trigger('analytics:proceedToLoyaltyModal');
            $('.modal-loyalty-registration-flow-custom .registrationModal-box').attr('data-registration-modal-stage', 'registration');
        });
    }

    loginAfterRegistration () {
        var url = $('form.login').attr('action');
        var email = $('#registration-form-email').val();
        var password = $('#registration-form-password').val();
        var csrfToken = $('input[name="csrf_token"]').val();
        var rememberMeChecked = $('#rememberMe').prop('checked') ? 'on' : null;
        var formData = {
            loginEmail: email,
            loginPassword: password,
            csrf_token: csrfToken,
            loginRememberMe: rememberMeChecked
        };
        $.spinner().start();

        // $('form.login').trigger('login:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (!data.success) {
                } else {
                    $('form.login').trigger('login:success', data);
                    location.reload();
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    $.spinner().stop();
                }
            }
        });
        return false;
    }

    formatDate (date, formatPattern) {
        if (formatPattern === 'dd-mm-yyyy') {
            return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
                date.getFullYear();
        } else if (formatPattern === 'mm-dd-yyyy') {
            return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
                date.getFullYear();
        } else if (formatPattern === 'yyyy年mm月dd日') {
            var dateParsed = (date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日');
            return dateParsed;
        }
    }

    closeRegistrationOpenLogin () {
        $('.close-button-info').trigger('click');
        $('.js-layer-login').first().trigger('click');
    }

    closeRegistrationOpenLoginRegistered () {
        $('.close-button-info').trigger('click');
        $('.js-layer-login').first().trigger('click');
        $('.gigyaLoginCell, .social-login-account-accept, .or-divider, .js-loginPopupFooter, .login-popup-spacer, .js-original-title').addClass('hidden');
        $('.button-login-form').css({'marginBottom': '0'});
        $('.js-layerLoginConfirmRegister').removeClass('hidden');
    }

    singleNumberOTPinput () {
        $('.otp-code-input-field').on('input', function () {
            var sanitizedInput = $(this).val().replace(/[^0-9]/g, '');
            sanitizedInput = sanitizedInput.substring(0, 1);
            $(this).val(sanitizedInput);
        });
    }

    shiftFieldWhileTypingInit () {
        $('.otp-code-input-field').on('input', function () {
            var maxLength = parseInt($(this).attr('maxlength'));
            var currentInputIndex = $('.otp-code-input-field').index(this);

            if ($(this).val().length === maxLength) {
                // Move to the next input field if available
                var nextInputIndex = currentInputIndex + 1;
                var nextInput = $('.otp-code-input-field').eq(nextInputIndex);

                if (nextInput.length) {
                    nextInput.focus();
                }
            }
        });

        $('.otp-code-input-field').on('keyup', function (e) {
            var currentInputIndex = $('.otp-code-input-field').index(this);

            if (e.keyCode === 8 && $(this).val().length === 0) {
                // Move to the previous input field if available
                var prevInputIndex = currentInputIndex - 1;
                var prevInput = $('.otp-code-input-field').eq(prevInputIndex);
                if (prevInput.length) {
                    prevInput.focus();
                }
            }
        });
    }

    updateButtonStatus () {
        var fname = $('#registration-form-fname').val();
        var lname = $('#registration-form-lname').val();
        var password = $('#registration-form-password').val();
        var confirmPassword = $('#registration-form-password-confirm').val();

        var allFieldsFilled = fname !== '' && lname !== '' && password !== '' && confirmPassword !== '';

        if (allFieldsFilled) {
            $('.register-form-button').prop('disabled', false);
        } else {
            $('.register-form-button').prop('disabled', true);
        }
    }

    updateButtonStatusInit () {
        var _self = this;
        $('#registration-form-fname, #registration-form-lname, #registration-form-password, #registration-form-password-confirm').on('input change', function () {
            _self.updateButtonStatus();
        });
        $('#registration-form-email').on('input change', function () {
            var isEmailFilled = $('#registration-form-email').val() !== '';
            $('.register-cta').prop('disabled', !isEmailFilled);
        });
        $('#registration-form-phone').on('input change', function () {
            var isPhoneFilled = $('#registration-form-phone').val() !== '';
            $('.registerPhoneButton').prop('disabled', !isPhoneFilled);
        });
    }

    closeLoginModal () {
        $('.layer-login-modal .js-close-login-popup').trigger('click');
    }

    isUserLoggedWaitingForLoyalty () {
        return $('.js-modal-loyalty-registration-fake').val() === 'user-is-logged';
    }

    isUserLoyaltyForThisBrand (customerFidelitySubscriptions) {
        if (customerFidelitySubscriptions.length === 0) {
            return false;
        }
        var url = window.location.href;
        for (var i = 0; i < customerFidelitySubscriptions.length; i++) {
            var subscriptionNodeBrandCode = (customerFidelitySubscriptions[i].subscriptionNodeBrandCode).toLowerCase();
            var isLoyaltyForThisBrand = url.indexOf(subscriptionNodeBrandCode) > -1;
            if (isLoyaltyForThisBrand) {
                return true;
            }
        }
        return false;
    }

    forgotPassword (e) {
        $('.close-button-info').trigger('click');
        e.preventDefault();
        const htmlContent = $('#requestPasswordResetModal').clone().html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false, ['layer-password-modal']);
        modal.open();
        Customer.resetPasswordForm();
        $(modal.modalBox).find('.request-password-title').removeClass('hidden');
        $(modal.modalBox).find('.social-request-password-title').addClass('hidden');
        $(modal.modalBox).find('.ico-center-send-mail').addClass('hidden');
        $(modal.modalBox).find('.request-password-body-description').removeClass('hidden');
        $(modal.modalBox).find('.social-request-password-body-description').addClass('hidden');
        $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });
    };
}

const registrationHelper = new RegistrationHelper();
export default registrationHelper;
